import type Leave from 'modules/timeoff/store/models/Leave'

const DEFAULT_PERMISSIONS = {
  approve: false,
  update: false,
  remove: false,
  manageLeaveDocuments: false,
  readOnly: true,
  readOnlyFields: false,
}
interface Props {
  leaveLoading: boolean
  leave: Leave
}

export interface ReturnType {
  approve: boolean
  update: boolean
  remove: boolean
  manageLeaveDocuments: boolean
  readOnly: boolean
  readOnlyFields: boolean
}

const usePermissions = ({ leaveLoading, leave }: Props): ReturnType => {
  if (leaveLoading) return DEFAULT_PERMISSIONS

  const approve = leave.policy.can('approveLeave')
  const update = leave.policy.can('updateLeave')
  const manageLeaveDocuments = leave.policy.can('manageLeaveDocuments')
  const remove = leave.policy.can('deleteLeave')

  return {
    approve,
    update,
    manageLeaveDocuments,
    remove,
    readOnly: !approve && !update && !manageLeaveDocuments && !remove,
    readOnlyFields: !update || leave.isRejected(),
  }
}

export default usePermissions
